const initialState = {
  user: null,
  loading: false,
  error: null,
  selectedStore: null,
  masterStore: null,
 contractType: null,
 subscriptionEndDate:null,

};

const loginReducer = (state = initialState, action) => {
  switch (action.type) {
    case 'LOGIN_USER_REQUEST':
      return { ...state, loading: true };
    // case 'LOGIN_USER_SUCCESS':
    //   return { ...state, loading: false, user: action.payload };
    case 'LOGIN_USER_SUCCESS':
      return {
        ...state,
        loading: false,
        user: {
          ...state.user,           // keep existing user info if any
          ...action.payload,       // overwrite with new payload
          result: {
            ...state.user?.result, // keep existing result
            ...action.payload?.result, // overwrite result with new payload
          },
        },
        // preserve masterStore if already set
        masterStore: state.masterStore ||
          (action.payload?.result?.is_master_store
            ? {
              store_id: action.payload.result.company_id,
              store_name: action.payload.result.company_name,
              store_email: action.payload.result.email,
              is_master: true,
            }
            : null),
      };
    case 'LOGIN_USER_FAILURE':
      return { ...state, loading: false, error: action.payload };
    case 'LOGOUT_USER_SUCCESS':
      // return { ...state, loading: false, user: action.payload };
      return { ...initialState };
    case "SET_SELECTED_STORE":
      return {
        ...state,
        selectedStore: action.payload,
      };
    case "SET_USER":
      return {
        ...state,
        user: action.payload,
      };
    case "SET_IS_MASTER_STORE":
      return {
        ...state,
        user: {
          ...state.user,
          result: {
            ...state.user?.result,
            is_master_store: action.payload,
          },
        },
      };
    case "SET_MASTER_STORE":
      return { ...state, masterStore: action.payload };
      case "SET_CONTRACT_TYPE":
  return {
    ...state,
    contractType: action.payload,
  };
  case "SET_END_DATE":
  return {
    ...state,
    subscriptionEndDate: action.payload,
  };
    default:
      return state;
  }
};

export default loginReducer;
